import React, { Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

// component props interface
interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard = ({ children }: GuestGuardProps) => {
  const { isAuthenticated } = useAuth();

  // If user is already authenticated, redirect them to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Fragment>{children}</Fragment>;
};

export default GuestGuard;
